import React from 'react';
import HeroSection from '../components/HeroSection';
import FeaturedTrips from '../components/FeaturedTrips';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';

const Home = () => {
    return (
        <div className="bg-gray-50">
            <HeroSection />
            <FeaturedTrips />
            <Testimonials />
            <Footer />
        </div>
    );
};

export default Home;
